import store from "../store";
import Constants from "../config/constants";
import { serviceGetSpecialClaimsList } from "../services/Claims.service";

export const FETCH_INIT = "FETCH_INIT_SPECIAL_CLAIMS";
export const FETCHED = "FETCHED_SPECIAL_CLAIMS";
export const FETCHED_FAIL = "FETCHED_FAIL_SPECIAL_CLAIMS";
export const FETCHED_FILTER = "FETCHED_FILTER_SPECIAL_CLAIMS";
export const FETCH_NEXT = "FETCH_NEXT_SPECIAL_CLAIMS";
export const FILTER = "FILTER_SPECIAL_CLAIMS";
export const RESET_FILTER = "RESET_FILTER_SPECIAL_CLAIMS";
export const SET_SORTING = "SET_SORTING_SPECIAL_CLAIMS";
export const SET_FILTER = "SET_FILTER_SPECIAL_CLAIMS";
export const SET_PAGE = "SET_PAGE_SPECIAL_CLAIMS";
export const CHANGE_PAGE = "CHANGE_PAGE_SPECIAL_CLAIMS";
export const CHANGE_STATUS = "CHANGE_STATE_SPECIAL_CLAIMS";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_SPECIAL_CLAIMS";
export const CREATE_DATA = "CREATE_SPECIAL_CLAIMS";
export const UPDATE_DATA = "UPDATE_SPECIAL_CLAIMS";
export const DELETE_ITEM = "DELETE_SPECIAL_CLAIMS";

export function actionFetchSpecialClaims(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetSpecialClaimsList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageSpecialClaims(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterSpecialClaims(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusSpecialClaims(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterSpecialClaims() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageSpecialClaims(page) {
  const stateData = store.getState().special_claims;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchSpecialClaims(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
